import { Button, Card, CardActions, CardContent, CardHeader } from "@mui/material";
import { useTranslation } from "react-i18next";

type CookiesConsentStepOneProps = {
  onClickConfigurePreferences: () => void;
  onAcceptCookies: () => void;
  onRejectCookies: () => void;
};
const CookiesConsentStepOne = ({
  onClickConfigurePreferences,
  onAcceptCookies,
  onRejectCookies,
}: CookiesConsentStepOneProps) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ maxWidth: 400 }} className="cookies-consent">
      <CardHeader
        titleTypographyProps={{
          fontSize: 12,
        }}
        title={t("legal-section.cookies-consent.title")}
      />
      <CardContent>
        {t("legal-section.cookies-consent.text")}
        <Button size="small" onClick={onClickConfigurePreferences}>
          {t("legal-section.cookies-consent.here")}
        </Button>
      </CardContent>
      <CardActions style={{ justifyContent: "center" }}>
        <Button variant="contained" size="small" onClick={onAcceptCookies}>
          {t("legal-section.cookies-consent.accept")}
        </Button>
        <Button variant="contained" size="small" onClick={onRejectCookies}>
          {t("legal-section.cookies-consent.reject")}
        </Button>
      </CardActions>
    </Card>
  );
};

export default CookiesConsentStepOne;
